import React from 'react';

import { Box, Text } from '@opendoor/bricks-next';

interface MobileMenuSectionHeaderProps {
  label: string;
}

export const MobileMenuSectionHeader: React.FC<MobileMenuSectionHeaderProps> = ({ label }) => {
  return (
    <Box
      backgroundColor="$backgroundSecondary"
      borderTopWidth={1}
      borderBottomWidth={1}
      borderColor="$borderPrimary"
      paddingTop="$8x"
      paddingBottom="$8x"
      paddingLeft="$12x"
      paddingRight="$8x"
    >
      <Text tag="span" typography="$labelSmall" color="$contentTertiary">
        {label}
      </Text>
    </Box>
  );
};
